module.exports = __webpack_public_path__ + "statics/img/wechat.425a0fc4.png";